import { isHttpClientError } from 'core/infra/http/HttpClient'

import { isTokenExpiredError } from './isTokenExpiredError'

const GATEWAY_FORBIDDEN_MESSAGE = 'forbidden_access'

/**
 * True for 401s on invite endpoints that are not the dedicated "token expired"
 * response, and for the api/v2 gateway authorizer's refusal, which surfaces as
 * 403 {"message": "forbidden_access"} instead of a backend 401.
 * Covers anonymous / missing / invalid credentials after enforcement.
 */
export function isUnauthorizedInviteError(error: unknown): boolean {
  if (!isHttpClientError(error)) {
    return false
  }

  if (error.response?.status === 403) {
    const data = error.response.data as { message?: string } | undefined

    return data?.message === GATEWAY_FORBIDDEN_MESSAGE
  }

  if (error.response?.status !== 401) {
    return false
  }

  return !isTokenExpiredError(error)
}
